<template>
	<section class="new-event-about-brazil">
		<div class="new-event-about-brazil__video-band">
			<div class="new-event-about-brazil__video-frame">
				<iframe
					:src="videoUrl"
					title="Informações Gerais do Brasil"
					frameborder="0"
					allow="autoplay; fullscreen; picture-in-picture"
					allowfullscreen
				></iframe>
			</div>
		</div>

		<article class="new-event-about-brazil__content">
			<h2>{{translation.title}}</h2>

			<section
				v-for="(content, index) in translation.content"
				:key="`${content.menu}-${index}`"
				class="new-event-about-brazil__section"
			>
				<h3>{{content.menu}}</h3>
				<p v-if="content.content">{{content.content}}</p>
				<div v-else class="new-event-about-brazil__rich-text" v-html="contentHtmlFor(content)"/>
			</section>
		</article>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';

const ABOUT_BRAZIL_VIDEO_URL = 'https://www.youtube.com/embed/ttaaMUsnaZc?autoplay=1&mute=1&loop=1&controls=0&playlist=ttaaMUsnaZc&modestbranding=1&showinfo=0&rel=0';

export default {
	computed: {
		translation() {
			return translate(this.$store.state.language).aboutBrazil;
		},
		videoUrl() {
			return ABOUT_BRAZIL_VIDEO_URL;
		},
	},
	methods: {
		contentHtmlFor(content) {
			return (content.contentHtml || '').replace(/<style[\s\S]*?<\/style>/gi, '');
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-about-brazil {
	background: #ffffff;
	color: #5a5a5a;
}

.new-event-about-brazil__video-band {
	background: #eeeeee;
	padding: 4px 0;
}

.new-event-about-brazil__video-frame {
	position: relative;
	width: calc(100% - 512px);
	max-width: 1222px;
	margin: 0 auto;
	aspect-ratio: 1222 / 575;
	overflow: hidden;
	background: #d9d9d9;
}

.new-event-about-brazil__video-frame iframe {
	position: absolute;
	inset: 0;
	display: block;
	width: 100%;
	height: 100%;
	border: 0;
}

.new-event-about-brazil__content {
	width: calc(100% - 188px);
	max-width: 1540px;
	margin: 0 auto;
	padding: 87px 0 100px;
}

.new-event-about-brazil__content h2 {
	margin: 0 0 57px;
	color: #163560;
	font-size: 28px;
	font-weight: 900;
	line-height: 33px;
}

.new-event-about-brazil__section {
	margin-bottom: 34px;
}

.new-event-about-brazil__section h3 {
	margin: 0 0 8px;
	color: #5da3bd;
	font-size: 23px;
	font-weight: 700;
	line-height: 35px;
}

.new-event-about-brazil__section p,
.new-event-about-brazil__rich-text {
	margin: 0;
	color: #5a5a5a;
	font-size: 20px;
	font-weight: 400;
	line-height: 35px;
}

.new-event-about-brazil__rich-text ::v-deep ul {
	margin: 18px 0;
	padding-left: 34px;
}

.new-event-about-brazil__rich-text ::v-deep li {
	margin-bottom: 10px;
}

@media (max-width: 1200px) {
	.new-event-about-brazil__video-frame {
		width: 82%;
	}
}

@media (max-width: 900px) {
	.new-event-about-brazil__video-band {
		padding: 0;
	}

	.new-event-about-brazil__video-frame,
	.new-event-about-brazil__content {
		width: 90%;
	}

	.new-event-about-brazil__content {
		padding: 48px 0 72px;
	}

	.new-event-about-brazil__content h2 {
		margin-bottom: 34px;
		font-size: 23px;
		line-height: 29px;
	}

	.new-event-about-brazil__section h3 {
		font-size: 19px;
		line-height: 29px;
	}

	.new-event-about-brazil__section p,
	.new-event-about-brazil__rich-text {
		font-size: 16px;
		line-height: 27px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/destination-info/AboutBrazil.vue